import React, { Fragment, useEffect, useState } from 'react'
import { Typography } from '@mui/material'

import {
  Accordion,
  AccordionDetails,
  AccordionSummary
} from '../../common/AbstractAccordion/AccordionMUI'
import { ColorBoxContent, ColorBoxHeader } from '../../common/ui/colorBox'

export default function FAQPage() {
  const [expanded, setExpanded] = useState('')

  const handleChange = (panel) => (_event, newExpanded) => {
    setExpanded(newExpanded ? panel : false)
  }

  const FAQs = [
    {
      key: 'get-started',
      q: 'How do I get started?',
      a: "On your profile, click on the walkthrough button and choose a specific tour you want to go on. We'll bring you through a comprehensive yet simple tour around our website!"
    },
    {
      key: 'contact-rep',
      q: 'How do I contact a representative of Orbit??',
      a: 'On the navigation panel, click on the customer support button. You can choose to contact us or generate a ticket and we will respond as soon as possible!'
    },
    {
      key: 'app-access',
      q: 'How do I set specific app access??',
      a: "On your profile, click on the walkthrough button and choose a specific tour you want to go on. We'll bring you through a comprehensive yet simple tour around our website!"
    }
  ]

  useEffect(() => {
    setExpanded(FAQs[0].key)
  }, [])

  return (
    <>
      <ColorBoxHeader>Frequently Asked Questions</ColorBoxHeader>
      <ColorBoxContent style={{ marginTop: 12 }}>
        <div>
          {FAQs.map((FAQ) => {
            return (
              <Fragment key={FAQ.key}>
                <Accordion
                  expanded={expanded === FAQ.key}
                  onChange={handleChange(FAQ.key)}
                >
                  <AccordionSummary
                    aria-controls={`${FAQ.key}-content`}
                    id={`${FAQ.key}-header`}
                  >
                    <Typography> {FAQ.q} </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>{FAQ.a}</Typography>
                  </AccordionDetails>
                </Accordion>
              </Fragment>
            )
          })}
        </div>
      </ColorBoxContent>
    </>
  )
}
